module.exports = __webpack_public_path__ + "static/lanside-28d3d285b12d7ca7e8cae8218f1ccf83.png";